import React, { Component } from 'react'
import SwipeableViews from 'react-swipeable-views'
import MobileStepper from 'material-ui/MobileStepper'
import KeyboardArrowLeft from 'material-ui-icons/KeyboardArrowLeft'
import KeyboardArrowRight from 'material-ui-icons/KeyboardArrowRight'
import Button from 'material-ui/Button'
import { withStyles } from 'material-ui/styles'
import { ExtraBold } from 'shared/textStyles'
import {
  Delila,
  Austin,
  Clinton,
  Loukas,
  Jeff,
  Stefan,
  Doug,
  Marcus,
  Quinn,
} from 'components/PersonnelInfo'

class NovoPersonnel extends Component {
  state = {
    founderIndex: 0,
    devTeamIndex: 0,
  }

  handleFounderChangeIndex = index => {
    this.setState({ founderIndex: index })
  }

  handleDevTeamChangeIndex = index => {
    this.setState({ devTeamIndex: index })
  }

  handleFounderNext = () => {
    this.setState({
      founderIndex: this.state.founderIndex + 1,
    })
  }

  handleFounderBack = () => {
    this.setState({
      founderIndex: this.state.founderIndex - 1,
    })
  }

  handleDevNext = () => {
    this.setState({
      devTeamIndex: this.state.devTeamIndex + 1,
    })
  }

  handleDevBack = () => {
    this.setState({
      devTeamIndex: this.state.devTeamIndex - 1,
    })
  }

  render() {
    const { classes } = this.props

    return (
      <div>
        <ExtraBold color="novo-dark-gray" margin="0 0 8px 0" size="20">
          Founders
        </ExtraBold>

        <div>
          <Clinton />
          <Loukas />
        </div>

        <ExtraBold color="novo-dark-gray" margin="36px 0 8px 0" size="20">
          Development Team
        </ExtraBold>

        <MobileStepper
          classes={{
            root: classes.mobileStepperRoot,
          }}
          variant="dots"
          steps={7}
          position="static"
          activeStep={this.state.devTeamIndex}
          nextButton={
            <Button
              size="small"
              onClick={this.handleDevNext}
              disabled={this.state.devTeamIndex === 6}
            >
              <KeyboardArrowRight />
            </Button>
          }
          backButton={
            <Button
              size="small"
              onClick={this.handleDevBack}
              disabled={this.state.devTeamIndex === 0}
            >
              <KeyboardArrowLeft />
            </Button>
          }
        />

        <SwipeableViews
          index={this.state.devTeamIndex}
          onChangeIndex={this.handleDevTeamChangeIndex}
        >
          <Jeff />
          <Austin />
          <Doug />
          <Delila />
          <Stefan />
          <Marcus />
          <Quinn />
        </SwipeableViews>
      </div>
    )
  }
}

const muiStyles = {
  mobileStepperRoot: {
    background: 'rgba(0,0,0,0)',
    maxWidth: 450,
    margin: '0 auto',
    width: '70%',
  },
}

export default withStyles(muiStyles)(NovoPersonnel)



// WEBPACK FOOTER //
// ./src/components/NovoPersonnel.js